import { useAppSelector } from 'app/hooks';
import DishModal from 'components/DishModal';
import { ProvisionTimingProps } from 'models';
import { selectCustomerQuantity } from 'store/slices/customerQuantitySlice';
import { selectMenu, selectSubMenuGroup } from 'store/slices/mainSlice';
import { selectedMenubookId, selectMenuInfo } from 'store/slices/menuInfoSlice';
import { getSubmenuGroupFromMenubookId, initDishState } from 'utils';

interface MenuDetailModalProps {
  menubookId?: string;
  dishCode: string;
  onClose: () => void;
}

const MenuDetailModal = ({ menubookId = undefined, dishCode, onClose }: MenuDetailModalProps) => {
  const currentMenubookId = menubookId || useAppSelector(selectedMenubookId);
  const menuList = useAppSelector(selectMenu);
  const subMenuGroupData = useAppSelector(selectSubMenuGroup);
  const menuInfo = useAppSelector(selectMenuInfo);
  const customerQuantity = useAppSelector(selectCustomerQuantity);
  const submenuGroupInfo = getSubmenuGroupFromMenubookId(menuInfo, currentMenubookId, dishCode);

  const initState = initDishState(menuList, subMenuGroupData, submenuGroupInfo, customerQuantity);
  const dishInfo = menuList[dishCode];

  if (dishInfo?.timing_flg === '1' && dishInfo.timing_info_id && dishInfo.timing_info_id !== '0') {
    const provisionTiming: ProvisionTimingProps = {
      timing_flg: '1',
      timing_info_id: dishInfo.timing_info_id,
      selected_timing: '',
    };

    initState[0].provisionTiming = provisionTiming;
  }

  return (
    <DishModal
      type="add"
      menubookId={currentMenubookId}
      dishCode={dishCode}
      initState={initState}
      addedState={initState[0]}
      onClose={onClose}
    />
  );
};

export default MenuDetailModal;
